import React from "react";

const styles = {
  container: {
    backgroundColor: "#2d3946",
    minHeight: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "20px"
  },
  card: {
    backgroundColor: "white",
    padding: "40px",
    borderRadius: "12px",
    maxWidth: "500px",
    width: "100%",
    textAlign: "center",
    boxShadow: "0 4px 20px rgba(0,0,0,0.2)"
  },
  logo: {
    width: "100%",
    maxWidth: "260px",
    borderRadius: "8px",
    marginBottom: "20px"
  },
  title: {
    color: "#e4af2f",
    fontSize: "2.2rem",
    marginBottom: "15px",
    fontWeight: "bold"
  },
  text: {
    color: "#2d3946",
    fontSize: "1.2rem",
    lineHeight: "1.6",
    marginBottom: "25px"
  },
  button: {
    marginTop: "10px",
    padding: "12px 20px",
    fontSize: "18px",
    cursor: "pointer",
    borderRadius: "6px",
    backgroundColor: "#245485",
    color: "white",
    border: "none"
  }
};

export default function NotRegistered() {
  return (
    <div style={styles.container}>
      <div style={styles.card}>

        {/* ⭐ Logo */}
        <img
          src="/images/FITZONE.png"
          alt="FITZONE Logo"
          style={styles.logo}
        />

        <h1 style={styles.title}>Registration Not Found</h1>

        <p style={styles.text}>
          Sorry, we couldn't find your registration for this activity.<br />
          But don't worry — you can register now.
        </p>

        <button
          style={styles.button}
          onClick={() => (window.location.href = "/")}
        >
          Register Now
        </button>
      </div>
    </div>
  );
}
